import { getTopArticles } from "@/graphql/schemas/shared/utils/getArticles"
import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryAdmTopArticles = {
  async admTopArticles(parent, args, context, info) {
    const { admNumber, page, size, sort, year, lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user } = context

    await checkPermissions({
      user,
      admNumber: admNumber,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    const sortString = EinzaGraphiQLService.formatSortParam(sort)

    const graphiQLQueryObject = [
      {
        method: "admStatsByArticle",
        variables: { admNumber, page, size, ...(sortString && { sort: sortString }), year },
        fields: ["number", "numberOfElements", "totalElements", "totalPages"],
        expandedFields: {
          content: ["year", "admNumber", "sku", "revenue", "quantity", "margin", "amount"],
        },
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)

    const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.admStatsByArticle

    if (!einzaResponse?.content || einzaResponse?.content?.length <= 0) {
      throw new Error("Data could not be retrieved")
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const admStatsByArticle = await getTopArticles(einzaResponse?.content, client)

    return {
      total: einzaResponse.totalElements,
      items: admStatsByArticle,
      page,
      size,
      sort,
      totalPages: einzaResponse.totalPages,
    }
  },
}
